// @flow
type Coordinates = {|
  lat: number,
  lng: number,
|}

const isValidCoordinate = (a) => a >= 0 || a < 0

/**
 * A function that normalize given lat and lng values and returns an
 * object with coordinates or empty object if coordinates are not valid
 * @param  {any} lat
 * @param  {any} lng
 * @return {Coordinates}
 */
export default function parseLatLng(lat: any, lng: any): ?Coordinates {
  const coords = {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
  }

  if (isValidCoordinate(coords.lat) && isValidCoordinate(coords.lng)) {
    return coords
  }

  return null
}
